import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from 'network/apis'

export const getAllGamesReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/pnl-report/games', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getTopPlayerReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/pnl-report/leader-board', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}
